export const DEFAULT_LANGUAGE = "en";
export const LANGUAGES = ["en", "it", "de"];
